import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MessageList from './MessageList';
import MessageDetail from './MessageDetail';
import About from './About';
import Contact from './Contact';
import Sponsor from './Sponsor';
import Timeline from './Timeline';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"         element={<MessageList />} />
        <Route path="/timeline" element={<Timeline />} />
        <Route path="/about"    element={<About />} />
        <Route path="/contact"  element={<Contact />} />
        <Route path="/sponsor"  element={<Sponsor />} />
        <Route path="/:id"      element={<MessageDetail />} />
      </Routes>
    </BrowserRouter>
  );
}
